import { useRef } from 'react'
import Styles from './ViewPostButton.module.scss'
import { useButton } from '@react-aria/button'
import { EyeOpen } from 'blaze-ui/icons'

const ViewPostButton = ({ onPress }: { onPress?: () => void }) => {
  const ref = useRef<HTMLButtonElement>(null)
  const { buttonProps } = useButton({ onPress }, ref)

  return (
    <button {...buttonProps} ref={ref} className={Styles.root}>
      <EyeOpen size={16} color="var(--dark-80)" />
    </button>
  )
}

export default ViewPostButton
